<template>
  <div
    class="vx-card mol-card-interaction aisea-pt-7 aisea-pb-7 aisea-pl-9 aisea-pr-9 aisea-rounded-2"
    :class="{ selected: isSelected }"
    @click="jumpToPlot(plot)"
  >
    <vs-row vs-type="flex" vs-justify="center" vs-align="center">
      <vs-col vs-w="2">
        <img class="icon-size" :src="img" />
      </vs-col>

      <vs-col vs-w="10">
        <div class="aisea-text-16-600-white card-content truncate">
          {{ plot.title }}
        </div>
        <div class="plot-range-datetime">
          <vs-row
            class="card-content"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-col class="aisea-text-12-600-white" vs-w="3">表示開始</vs-col>
            <vs-col
              class="aisea-text-12-300-white aisea-pl-3 truncate"
              vs-w="9"
            >
              <span v-if="plot.detail.start_date">{{
                plot.detail.start_date | toYMDHM
              }}</span>
              <span v-else>-</span>
            </vs-col>
          </vs-row>
          <vs-row
            class="card-content"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vs-col class="aisea-text-12-600-white" vs-w="3">表示終了</vs-col>
            <vs-col
              class="aisea-text-12-300-white aisea-pl-3 truncate"
              vs-w="9"
            >
              <span v-if="plot.detail.end_date">{{
                plot.detail.end_date | toYMDHM
              }}</span>
              <span v-else>-</span>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
      <vs-col vs-w="3" vs-justify="flex-end" vs-type="flex"> </vs-col>
    </vs-row>
  </div>
</template>

<script>
/**
 * プロット情報カードの一つを描画するコンポーネント
 * @parent O.Plot
 * @props plot: Object プロットの詳細データの一つ
 * @props jumpToPlot: プロット選択時にvuexの追跡情報とFireStoreの追跡情報を更新しする関数
 * @props isSelected: Boolean 現在の選択状態を管理
 */
import { PLOT_CHILD_CATEGORY } from "@/config/const";

// Mixins
import { ColorMixin } from "@/mixins";

export default {
  name: "M.PlotCard",
  mixins: [ColorMixin],
  props: {
    plot: Object,
    jumpToPlot: {
      type: Function,
      required: true,
    },
    isSelected: {
      type: Boolean,
    },
  },
  computed: {
    img() {
      return require("@/assets/images/plot/" +
        PLOT_CHILD_CATEGORY.properties[this.plot.child_category.id].img +
        ".png");
    },
    plotIcon() {
      return require("@/assets/images/icons/sideber-menu/plot.svg");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.vx-card {
  cursor: pointer;
  width: 360px;
  height: 100px;
  margin: 0 auto;

  .icon-size {
    height: 2rem;
  }

  .card-content {
    margin-bottom: 3px;
  }
}

.mol-card-interaction {
  background-color: $aisea-blue-gray;

  &:hover {
    background-color: #6a717d;
  }

  &:active {
    background-color: #969ba4;
  }
}

.mol-card-interaction.selected {
  background-color: #1b5e83;
  outline: 2px solid #2d9cdb;

  &:hover {
    background-color: #588eac;
  }

  &:active {
    background-color: #98b6c7;
  }
}
</style>
